<script setup>
import SectionHeader from "../texts/SectionHeader.vue";
import InvoiceTotals from "../invoices/InvoiceTotals.vue";
</script>

<template>
    <div class="align-center">
        <SectionHeader label="Cost Summary" />
        <InvoiceTotals />
    </div>
</template>
